import React from "react";
import "./StatusStudentInfo.scss";

const StatusStudentInfo = ({status = "Onshore"}) => {
  return (
    <div className="status-student__container">
      <div className="status-student__container--wrapper">
        <p className={`${status === "Onshore" ? "isOnShore" : "isOffShore"}`}>
          {status}
        </p>
      </div>
    </div>
  );
};

export default StatusStudentInfo;
